export default {
  submitButton: {
    id: 'payment_form_submit_button_pay_with',
    defaultMessage: 'Pay with {providerName}',
  },
}
